export default __webpack_public_path__ + "static/media/bspring32.1134cbc9.webp";